import { apiClient } from "./client";

export interface VapidKeyResponse {
  publicKey: string;
}

export interface PushSubscriptionPayload {
  endpoint: string;
  keys: {
    p256dh: string;
    auth: string;
  };
  userAgent?: string;
}

export async function getVapidPublicKey(): Promise<VapidKeyResponse> {
  return apiClient.get<VapidKeyResponse>("/api/push/vapid-public-key");
}

export async function subscribeToPush(payload: PushSubscriptionPayload): Promise<{ saved: true }> {
  return apiClient.post<{ saved: true }>("/api/push/subscriptions", payload);
}

export async function unsubscribeFromPush(endpoint: string): Promise<{ deleted: true }> {
  return apiClient.post<{ deleted: true }>("/api/push/unsubscribe", { endpoint });
}

// ─── Native device push (Expo / FCM / APNs) ──────────────────────────────────

export interface DevicePushPayload {
  /** Expo push token (ExponentPushToken[...]) or a raw FCM/APNs token. */
  token: string;
  platform: "ios" | "android";
}

/**
 * Register a native device push token (mobile) via
 * `POST /api/push/device-token`. The web path uses Web Push (VAPID,
 * `subscribeToPush`); native devices send an Expo/FCM/APNs token here.
 */
export async function registerPushDevice(
  payload: DevicePushPayload
): Promise<{ saved: boolean }> {
  return apiClient.post<{ saved: boolean }>("/api/push/device-token", payload);
}

/**
 * Unregister a native device push token (called on logout so a signed-out
 * device stops receiving pushes). Best-effort: the matching
 * `DELETE /api/push/device-token` route is not deployed server-side yet, so
 * callers must swallow failures.
 */
export async function deletePushDeviceToken(
  token: string
): Promise<{ deleted: boolean }> {
  return apiClient.delete<{ deleted: boolean }>(
    `/api/push/device-token?token=${encodeURIComponent(token)}`
  );
}
